import { NAME as name } from './constants';
import { createActionTypes } from '../core';

const NAME = name.toUpperCase();

export const FINISH_TOUR = createActionTypes(`${NAME}/FINISH_TOUR`);

export const FINISH_PRODUCT_TOUR = createActionTypes(`${NAME}/FINISH_PRODUCT_TOUR`);
